import { alpha, Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

export const DashBoxStyles = (theme: Theme) => createStyles({

    root: {
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 4,
        backgroundColor: theme.palette.common.white,
        padding: theme.spacing(),
        marginRight: "4px",
        minWidth: 236
    },

    primary: {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
    },

    secondary: {
        color: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
    },
    error: {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
    },
    info: {
        color: theme.genie.palette.info.main,
        borderColor: theme.genie.palette.info.main,
    },
    success: {
        color: theme.genie.palette.success.main,
        borderColor: theme.genie.palette.success.main,
    },
    warning: {
        color: theme.genie.palette.warning.main,
        borderColor: theme.genie.palette.warning.main,
    },
    muted: {
        color: theme.genie.palette.muted.dark,
        borderColor: theme.genie.palette.muted.dark,
    },

    active: {
        "&$primary": { backgroundColor: alpha(theme.palette.primary.light, 0.4) },
        "&$secondary": { backgroundColor: alpha(theme.palette.secondary.light, 0.4) },
        "&$$error": { backgroundColor: alpha(theme.palette.error.light, 0.4) },
        "&$info": { backgroundColor: alpha(theme.genie.palette.info.light, 0.4) },
        "&$success": { backgroundColor: alpha(theme.genie.palette.success.light, 0.4) },
        "&$warning": { backgroundColor: alpha(theme.genie.palette.warning.light, 0.4) },
        "&$muted": { backgroundColor: alpha(theme.genie.palette.muted.dark, 0.4) },
    },

    icon: {
        "&$primary": { color: theme.palette.primary.dark },
        "&$secondary": { color: theme.palette.secondary.dark },
        "&$error": { color: theme.palette.error.dark },
        "&$info": { color: theme.genie.palette.info.dark },
        "&$success": { color: theme.genie.palette.success.dark },
        "&$warning": { color: theme.genie.palette.warning.dark },
        "&$muted": { backgroundColor: theme.genie.palette.muted.dark },
    },

    cursor: {
        cursor: "pointer"
    }
});
